import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../core/localization/localization.service';

@Pipe({
  name: 'localization'
})
export class LocalizationPipe implements PipeTransform {
  constructor(private localizationService: LocalizationService) { }

  transform(value: string): string {

    return this.localizationService.getLabel(value);
  }

}
